import pvhApi from '@/api/pvhApi'

import router from '@/router'

const state = () => ({
  status: {
    name: '',
    color: '#ffffff',
    is_close: false,
    is_manual: false,
    is_calculate: false,
    is_rollback: false,
    is_through: false,
    is_shaping: false,
    rights: [],
    right: { id: null, name: '' },
    right_id: null,
    period: '',
    fieldsList: [
      {
        access: false,
        field: 'code',
        title: 'Код КП'
      },
      {
        access: false,
        field: 'order_type',
        title: 'Тип заказа'
      },
      {
        access: false,
        field: 'status',
        title: 'Статус заказа'
      },
      {
        access: false,
        field: 'agent',
        title: 'Объект/Контрагент'
      },
      {
        access: false,
        field: 'value',
        title: 'Сумма по договору'
      },
      {
        access: false,
        field: 'delivery',
        title: 'Способ доставки'
      },
      {
        access: false,
        field: 'is_check',
        title: 'Проверено'
      },
      {
        access: false,
        field: 'gauger',
        title: 'Замерщик'
      },
      {
        access: false,
        field: 'installer',
        title: 'Установщик'
      },
      {
        access: false,
        field: 'gauging_date',
        title: 'Дата замера'
      },
      {
        access: false,
        field: 'advance_date',
        title: 'Предварительная дата готовности'
      },
      {
        access: false,
        field: 'availability_date',
        title: 'Дата готовности в цеху'
      },
      {
        access: false,
        field: 'installation_date',
        title: 'Дата установки'
      },
      {
        access: false,
        field: 'samples',
        title: 'Файлы с замерами'
      },
      {
        access: false,
        field: 'treaties',
        title: 'Файлы договора'
      },
      {
        access: false,
        field: 'other',
        title: 'Прочие файлы заказа'
      },
      {
        access: false,
        field: 'photographs',
        title: 'Фотографии'
      },
      {
        access: false,
        field: 'costs',
        title: 'Расходы'
      },
      {
        access: false,
        field: 'incomes',
        title: 'Приходы'
      },
      {
        access: false,
        field: 'client',
        title: 'Клиент'
      },
      {
        access: false,
        field: 'square_meters',
        title: 'Квадратные метры'
      },
      {
        access: false,
        field: 'count',
        title: 'Количество/шт.'
      },
      {
        access: false,
        field: 'code_ral',
        title: 'Код RAL'
      },
      {
        access: false,
        field: 'depth',
        title: 'Толщина'
      }
    ],
    fields: []
  },
  roles: [],
  validation: {
    name: { type: null, message: '' }
  },
  isLoading: true
})

const getters = {
  '[pvh] getStatusUpdateRoles': state => state.roles,
  '[pvh] getStatusForUpdate': state => state.status,
  '[pvh] getStatusUpdateValidation': state => state.validation,
  '[pvh] getStatusUpdateIsLoading': state => state.isLoading,
  '[pvh] getStatusInformerList': state => state.informTypeOptionList
}

const mutations = {
  '[pvh] GET_STATUS': (state, status) => {
    state.status = status
  },
  '[pvh] GET_STATUS_FOR_UPDATE': (state, status) => {
    let period = ''
    if (status.plain_period) {
      period = status.plain_period.toString()
    }
    state.status = {
      ...status,
      period: period,
      color: status.color ? status.color : '#173F7D',
      fieldsList: [
        {
          access: false,
          field: 'code',
          title: 'Код КП'
        },
        {
          access: false,
          field: 'order_type',
          title: 'Тип заказа'
        },
        {
          access: false,
          field: 'status',
          title: 'Статус заказа'
        },
        {
          access: false,
          field: 'agent',
          title: 'Объект/Контрагент'
        },
        {
          access: false,
          field: 'value',
          title: 'Сумма по договору'
        },
        {
          access: false,
          field: 'delivery',
          title: 'Способ доставки'
        },
        {
          access: false,
          field: 'is_check',
          title: 'Проверено'
        },
        {
          access: false,
          field: 'gauger',
          title: 'Замерщик'
        },
        {
          access: false,
          field: 'installer',
          title: 'Установщик'
        },
        {
          access: false,
          field: 'gauging_date',
          title: 'Дата замера'
        },
        {
          access: false,
          field: 'advance_date',
          title: 'Предварительная дата готовности'
        },
        {
          access: false,
          field: 'availability_date',
          title: 'Дата готовности в цеху'
        },
        {
          access: false,
          field: 'installation_date',
          title: 'Дата установки'
        },
        {
          access: false,
          field: 'samples',
          title: 'Файлы с замерами'
        },
        {
          access: false,
          field: 'treaties',
          title: 'Файлы договора'
        },
        {
          access: false,
          field: 'other',
          title: 'Прочие файлы заказа'
        },
        {
          access: false,
          field: 'photographs',
          title: 'Фотографии'
        },
        {
          access: false,
          field: 'costs',
          title: 'Расходы'
        },
        {
          access: false,
          field: 'incomes',
          title: 'Приходы'
        },
        {
          access: false,
          field: 'client',
          title: 'Клиент'
        },
        {
          access: false,
          field: 'square_meters',
          title: 'Квадратные метры'
        },
        {
          access: false,
          field: 'count',
          title: 'Количество/шт.'
        },
        {
          access: false,
          field: 'code_ral',
          title: 'Код RAL'
        },
        {
          access: false,
          field: 'depth',
          title: 'Толщина'
        }
      ],
      right: status.right ? { 
        id: status.right.id, 
        name: status.right.name 
      } : null,
      fields: status.fields ? status.fields.map(item => item.field) : []
    }
    state.isLoading = false
  },
  '[pvh] SET_STATUS_UPDATE_NAME': (state, value) => {
    state.status.name = value
  },
  '[pvh] SET_STATUS_UPDATE_PERIOD': (state, value) => {
    state.status.period = value
  },
  '[pvh] SET_STATUS_UPDATE_COLOR': (state, value) => {
    state.status.color = value
  },
  '[pvh] SET_STATUS_UPDATE_CLOSE': (state) => {
    state.status.is_close = !state.status.is_close
  },
  '[pvh] SET_STATUS_UPDATE_MANUAL': (state) => {
    state.status.is_manual = !state.status.is_manual
  },
  '[pvh] SET_STATUS_UPDATE_SHAPING': (state) => {
    state.status.is_shaping = !state.status.is_shaping
  },
  '[pvh] SET_STATUS_UPDATE_THROUGH': (state) => {
    state.status.is_through = !state.status.is_through
  },
  '[pvh] SET_STATUS_UPDATE_ROLLBACK': (state) => {
    state.status.is_rollback = !state.status.is_rollback
  },
  '[pvh] SET_STATUS_UPDATE_CALCULATE': (state) => {
    state.status.is_calculate = !state.status.is_calculate
  },
  '[pvh] CHANGE_STATUS_UPDATE_FIELD_CHECK': (state, field) => {
    const fields = state.status.fields
    if (fields?.length > 0) {
      if (fields.some(elem => elem === field)) {
        const newFields = fields.filter(function (value) {
          return value !== field
        })
        state.status.fields = newFields
      } else {
        fields.push(field)
      }
    } else {
      fields.push(field)
    }
  },

  '[pvh] SET_STATUS_UPDATE_ROLE': (state, role) => {
    state.status.right = role
    state.status.right_id = role.id
  },

  '[pvh] SET_STATUS_ITEM_VALIDATION': (state, valid) => {
    if (valid?.name) {
      state.validation.name.message = valid.name[0]
      state.validation.name.type = 'error'
    }
  },

  '[pvh] STATUS_UPDATE_CLEAR_VALIDATION': (state, inputName) => {
    // свитч кейсом очищать валидацию в нужном поле по имени инпута
    switch (inputName) {
      case 'name':
        state.validation.name = { type: null, message: '' }
        break
      default:
        break
    }
  },

  '[pvh] SET_STATUS_UPDATE_INITIAL_STATE': (state) => {
    state.status = {
      name: '',
      color: '#173F7D',
      is_close: false,
      is_manual: false,
      is_calculate: false,
      is_rollback: false,
      is_through: false,
      is_shaping: false,
      rights: [],
      right: { id: null, name: '' },
      right_id: null,
      period: '',
      fieldsList: [
        {
          access: false,
          field: 'code',
          title: 'Код КП'
        },
        {
          access: false,
          field: 'order_type',
          title: 'Тип заказа'
        },
        {
          access: false,
          field: 'status',
          title: 'Статус заказа'
        },
        {
          access: false,
          field: 'agent',
          title: 'Объект/Контрагент'
        },
        {
          access: false,
          field: 'value',
          title: 'Сумма по договору'
        },
        {
          access: false,
          field: 'delivery',
          title: 'Способ доставки'
        },
        {
          access: false,
          field: 'is_check',
          title: 'Проверено'
        },
        {
          access: false,
          field: 'gauger',
          title: 'Замерщик'
        },
        {
          access: false,
          field: 'installer',
          title: 'Установщик'
        },
        {
          access: false,
          field: 'gauging_date',
          title: 'Дата замера'
        },
        {
          access: false,
          field: 'advance_date',
          title: 'Предварительная дата готовности'
        },
        {
          access: false,
          field: 'availability_date',
          title: 'Дата готовности в цеху'
        },
        {
          access: false,
          field: 'installation_date',
          title: 'Дата установки'
        },
        {
          access: false,
          field: 'samples',
          title: 'Файлы с замерами'
        },
        {
          access: false,
          field: 'treaties',
          title: 'Файлы договора'
        },
        {
          access: false,
          field: 'other',
          title: 'Прочие файлы заказа'
        },
        {
          access: false,
          field: 'photographs',
          title: 'Фотографии'
        },
        {
          access: false,
          field: 'costs',
          title: 'Расходы'
        },
        {
          access: false,
          field: 'incomes',
          title: 'Приходы'
        },
        {
          access: false,
          field: 'client',
          title: 'Клиент'
        },
        {
          access: false,
          field: 'square_meters',
          title: 'Квадратные метры'
        },
        {
          access: false,
          field: 'count',
          title: 'Количество/шт.'
        },
        {
          access: false,
          field: 'code_ral',
          title: 'Код RAL'
        },
        {
          access: false,
          field: 'depth',
          title: 'Толщина'
        }
      ],
      fields: []
    }
  },
  '[pvh] ADD_STATUS_UPDATE_ROLE': (state, role) => {
    state.status.rights = state.status.rights ?? []
    state.status.rights.push(role)
  },
  '[pvh] REMOVE_STATUS_UPDATE_ROLE': (state, roleDelete) => {
    state.status.rights = state.status.rights.filter(role => {
      return role.id !== roleDelete.id
    })
  },
  '[pvh] GET_STATUS_UPDATE_ROLES': (state, roles) => {
    state.roles = roles.map(role => {
      return {
        name: role.name,
        id: role.id
      }
    })
  }

}

const actions = {
  '[pvh] getStatusUpdateRoles' ({ commit }) {
    const params = {
      currentTake: 100,
      currentPage: 1,
      searchFilter: ''
    }

    pvhApi.getRoleList(params).then(response => {
      commit('[pvh] GET_STATUS_UPDATE_ROLES', response.data.data)
    }).catch(error => {
      console.log('ошибка получения списка ролей', error)
    })
  },
  '[pvh] getStatusUpdateInfo' ({ commit, state }, id) {
    const params = {
      expands: 'expand=rights,fields,right',
      id
    }

    pvhApi.getStatusUpdateInfo(params).then(response => {
      commit('[pvh] GET_STATUS_FOR_UPDATE', response.data.data)
    }).catch(error => {
      console.log('ошибка получения статуса', error)
    })
  },
  '[pvh] setStatusName' ({ commit }, value) {
    commit('[pvh] SET_STATUS_UPDATE_NAME', value)
  },
  '[pvh] setStatusPeriod' ({ commit }, value) {
    commit('[pvh] SET_STATUS_UPDATE_PERIOD', value)
  },
  '[pvh] setStatusColor' ({ commit }, value) {
    commit('[pvh] SET_STATUS_UPDATE_COLOR', value)
  },
  '[pvh] setStatusManual' ({ commit }) {
    commit('[pvh] SET_STATUS_UPDATE_MANUAL')
  },
  '[pvh] setStatusClose' ({ commit }) {
    commit('[pvh] SET_STATUS_UPDATE_CLOSE')
  },
  '[pvh] setStatusShaping' ({ commit }) {
    commit('[pvh] SET_STATUS_UPDATE_SHAPING')
  },
  '[pvh] setStatusThrough' ({ commit }) {
    commit('[pvh] SET_STATUS_UPDATE_THROUGH')
  },
  '[pvh] setStatusRollback' ({ commit }) {
    commit('[pvh] SET_STATUS_UPDATE_ROLLBACK')
  },
  '[pvh] setStatusCalculate' ({ commit }) {
    commit('[pvh] SET_STATUS_UPDATE_CALCULATE')
  },

  '[pvh] statusUpdateClearValidation' ({ commit }, inputName) {
    commit('[pvh] STATUS_UPDATE_CLEAR_VALIDATION', inputName)
  },
  '[pvh] statusUpdateSaveInfo' ({ commit, state }, id, page = 'status') {
    const newRights = []
    const addRights = function (rights) {
      if (rights) {
        rights.forEach(e => (
          newRights.push(e.id)
        ))
      }
    }

    addRights(state.status.rights)

    const statusData = {
      name: state.status.name,
      fields: state.status.fields,
      color: state.status.color,
      is_calculate: state.status.is_calculate,
      is_close: state.status.is_close,
      is_manual: state.status.is_manual,
      is_pay_informing: state.status.is_pay_informing,
      is_rollback: state.status.is_rollback,
      is_shaping: state.status.is_shaping,
      is_through: state.status.is_through,
      rights: newRights,
      right_id: state.status.right_id,
      plain_period: state.status.period
    }

    if (id === 'create') {
      pvhApi.postStatusUpdateSaveInfo(statusData).then(response => {
        if (page === 'status') {
          router.push({ name: 'PvhStatusList' })
        }
      }).catch(error => {
        commit('[pvh] SET_STATUS_ITEM_VALIDATION', error.response.data.validation)
        console.log('Ошибка обновления статуса', error.response)
      })
    } else {
      pvhApi.putStatusUpdate(statusData, id).then(response => {
        if (page === 'status') {
          router.push({ name: 'PvhStatusList' })
        }
      }).catch(error => {
        commit('[pvh] SET_STATUS_ITEM_VALIDATION', error.response.data.validation)
        console.log('Ошибка обновления статуса', error.response)
      })
    }
  },
  '[pvh] setStatusUpdateInitialState' ({ commit, state }) {
    commit('[pvh] SET_STATUS_UPDATE_INITIAL_STATE', state)
  },
  '[pvh] statusesUpdateSetRole' ({ commit }, value) {
    commit('[pvh] SET_STATUS_UPDATE_ROLE', value)
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
